import { render, staticRenderFns } from "./AccountPhoneSendMessages.vue?vue&type=template&id=ee268996&scoped=true"
import script from "./AccountPhoneSendMessages.vue?vue&type=script&lang=js"
export * from "./AccountPhoneSendMessages.vue?vue&type=script&lang=js"
import style0 from "./AccountPhoneSendMessages.vue?vue&type=style&index=0&id=ee268996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee268996",
  null
  
)

export default component.exports